import { render } from "./vstatementplatform.vue?vue&type=template&id=1c26d11b&scoped=true"
import script from "./vstatementplatform.vue?vue&type=script&lang=js"
export * from "./vstatementplatform.vue?vue&type=script&lang=js"

import "./vstatementplatform.vue?vue&type=style&index=0&id=1c26d11b&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c26d11b"]])

export default __exports__